import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

export default function FeasibilityDialog({ open, report, onClose }) {
  if (!report) return null;
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="feasibility-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertTriangle className="w-5 h-5" />
            Plán je vygenerovaný, no nedá sa splniť bezo zvyšku
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            Zobrazili sme najlepší možný rozvrh. S aktuálnym personálom a požiadavkami sa však nedá dodržať všetko naraz – zvážte niektoré z opatrení. Rozhodnutie je na vás.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 max-h-[50vh] overflow-y-auto">
          <div>
            <div className="text-xs font-semibold text-slate-600 mb-1">Dôvody</div>
            <ul className="space-y-1">
              {report.reasons.map((r, i) => (
                <li key={i} data-testid={`feas-reason-${i}`} className="text-xs text-slate-600 flex gap-2">
                  <span className="text-amber-500">•</span>{r}
                </li>
              ))}
            </ul>
          </div>
          {report.proposals?.length > 0 && (
            <div>
              <div className="text-xs font-semibold text-slate-600 mb-1.5">Navrhované opatrenia</div>
              <div className="space-y-2">
                {report.proposals.map((p, i) => (
                  <div key={i} data-testid={`feas-proposal-${p.type}`} className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2">
                    <div className="text-sm font-medium text-slate-800">{p.label}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{p.detail}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <DialogFooter>
          <Button onClick={onClose} className="bg-slate-900 hover:bg-slate-800" data-testid="feas-close-btn">
            Rozumiem, zobraziť plán
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
